// pin-echo.js — did the pin we sent come back on the created defect?
// ---------------------------------------------------------------------
// 2026-08-20 — Midland incident close-out. When a defect is created from a
// dropped pin, the payload carries drawingId/markX/markY and the server
// echoes the row it inserted. Until today the client never looked: a
// response with the pin silently missing (historically possible — string
// coords nulled by a typeof check, a deleted drawing, a field dropped in a
// refactor) was added to the screen as if pinned, and the loss surfaced
// weeks later as "a defect nobody can find on a plan".
//
// The server now fails closed (api/shared/pin-fields.js), so a lost pin
// should be impossible — which is exactly why this check is cheap to keep:
// it is the alarm that says so if that ever regresses, at the moment it
// regresses, instead of on site three weeks later.
//
// Pure: (what we sent, what came back) → verdict. No IO, no UI.

/**
 * pinEcho(sentPayload, response) → one of
 *   { state: 'queued' }     — offline; the outbox owns it now (its sync log
 *                             reports a rejection if the replay 4xxs)
 *   { state: 'unpinned' }   — no pin was asked for; nothing to verify
 *   { state: 'pinned' }     — the pin survived the round trip
 *   { state: 'lost', message } — SENT a pin, response has no pin. Alarm.
 */
export function pinEcho(sent, response) {
  const askedForPin = !!sent && sent.drawingId != null && sent.markX != null && sent.markY != null;
  if (response && response.queued) return { state: 'queued' };
  if (!askedForPin) return { state: 'unpinned' };
  const echoed = !!response && response.drawingId != null && response.markX != null && response.markY != null;
  if (echoed) return { state: 'pinned' };
  return {
    state: 'lost',
    message: 'The item saved, but its PIN did not — it will show as unpinned in the register. Open the plan and re-pin it, and report this: it should be impossible.',
  };
}
